import React from "react";

import { showDialogAsync } from "../../dialog-queue";
import { ConfirmDialog } from "../../dialog/confirm";
import { labels } from "./labels";

export const showSaveDialogConfirmAsync = (projectname: string) =>
	showDialogAsync<boolean>(({ resolve }, { isOpen }) => (
		<ConfirmDialog
			cancelLabel={labels.cancel}
			titleLabel={labels.title}
			messageHtmlLabel={labels.messageHtml}
			messageHtmlReplacements={[projectname]}
			isOpen={isOpen}
			okLabel={labels.overwrite}
			onOk={() => resolve(true)}
			onCancel={() => resolve(false)}
		/>
	));
